"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
exports.Interaction = base_1.default;
var factory_1 = require("./factory");
exports.getInteraction = factory_1.getInteraction;
exports.registerInteraction = factory_1.registerInteraction;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/interaction/index.js
// module id = 604
// module chunks = 37